<script lang="ts" setup>
    import { ref, watch, onBeforeMount } from "vue"; 
    import Combo from '../components/Combo.vue';
    import {initPinia} from '../lib/PiniaMgr';
    import {useSimpleListStore} from '../lib/Stores/SimpleListStore';
    import {popAlert,ModalStyles} from '../lib/Notification';     
 
    // TODO: We should be converting to using a new process Beverly is developing.
    
    const simpleListStore = useSimpleListStore(initPinia());
    
    const emit = defineEmits<{
        (e: "onChange", selectedItem: any):void,
        (e: "onWarning", warningMessage: string):void,
        (e: "update:selected", selectedItem: any):void,
    }>();

    const selected = ref<string | number>();

    const props = withDefaults(defineProps<{
        listName: string,
        listWarning?: string,
        emitWarning?: boolean,
        includeHeader?: boolean,
        includeBlank?: boolean,
        selected?: string | number,
        size?: number,
        disabled?: boolean
    }>(), {     
        listWarning: "Invalid warning message",
        emitWarning: false, // true = emit warning, false = pop alert with warning
        includeBlank: false,
        includeHeader: false,
        disabled: false
    });

    onBeforeMount(() =>{
        selected.value = props.selected;
    });

    watch(() => props.selected, (_new, _old) => {
        if (_new !== _old) {
            selected.value = _new;
        }
    });
  
    async function onChange(selectedItem : any) : Promise<void> {
        if (!selectedItem) {            
            emit("onChange",undefined);
            emit("update:selected",undefined);
            return;
        }
        if ("warningMessage" in selectedItem) {
            if (selectedItem.warningMessage != "") {
                if (props.emitWarning) {
                    emit("onWarning",selectedItem.warningMessage);
                }
                else {
                    await popAlert((selectedItem.warningMessage === "*" ? props.listWarning : selectedItem.warningMessage),"Warning",ModalStyles.warning);
                }
            }
        }
        emit("onChange",selectedItem);
        emit("update:selected",selectedItem.value);
    } 
</script>

<template>
    <Combo
        :optionList="simpleListStore.listResult[props.listName]" 
        :includeHeader="props.includeHeader"
        :includeBlank="props.includeBlank"
        :size="props.size"
        :disabled="props.disabled"
        v-model:selected="selected"
        @onChange="onChange" 
    />
</template>